<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align:center">I would like to thank Joanne Barbera, Laura Kusic and Dr. Nicolas Barbera for their patience, time and effort in helping to make this book a reality.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?336b327b